import { ComponentPropsWithoutRef, useContext } from 'react';
import { Separator } from '@givebutter/primitives/separator';
import { DeleteGroupButton } from 'components/filter/filters-next/DeleteGroupButton';
import { FilterBar } from 'components/filter/filters-next/FilterBar';
import {
    FilterGroupProvider,
    IFilterGroupContext,
} from 'components/filter/filters-next/FilterGroupContext';
import { FilterProviderContext } from 'components/filter/filters-next/FilterProvider';
import { OuterGroupOperator } from 'components/filter/filters-next/OuterGroupOperator';
import { QuickFiltersBarProps } from 'components/filter/filters-next/QuickFiltersBar';
import { SegmentBar } from 'components/filter/filters-next/SegmentBar';
import { SegmentContext } from 'components/filter/filters-next/SegmentContext';
import { useFiltersByKey } from 'components/filter/filters-next/useFiltersByKey';
import { useCurrentSegment } from 'customHooks/useCurrentSegment';
import { twMerge } from 'tailwind-merge';

interface FilterGroupBarProps
    extends ComponentPropsWithoutRef<'div'>,
        QuickFiltersBarProps,
        Omit<IFilterGroupContext, 'groupId'> {}

const FilterGroupBar = (props: FilterGroupBarProps) => {
    const {
        showOuterOperator = true,
        showInnerOperator = true,
        quickFilters: quickFilterKeys = [],
        className = '',
        ...rest
    } = props;
    const { cacheKey, readOnly } = useContext(FilterProviderContext);
    const { filterGroups = [] } = useFiltersByKey(cacheKey);
    const { isEditing } = useContext(SegmentContext);
    const isViewingSegment = useCurrentSegment();

    return (
        <div className={twMerge('flex w-full flex-col gap-4', className)} {...rest}>
            {isViewingSegment && (
                <div className={'flex flex-col gap-3'}>
                    <SegmentBar className={'px-2'} />
                    {isEditing && <Separator className={`-mx-4 !w-auto`} />}
                </div>
            )}
            {((isViewingSegment && isEditing) || !isViewingSegment) &&
                filterGroups.map((group, i) => {
                    return (
                        <FilterGroupProvider
                            key={group.id}
                            groupId={group.id}
                            showInnerOperator={showInnerOperator}
                            showOuterOperator={showOuterOperator}
                        >
                            {showOuterOperator && i !== 0 && (
                                <div className={'flex items-center gap-4'}>
                                    <Separator />
                                    <OuterGroupOperator />
                                    <Separator />
                                </div>
                            )}
                            <div className={'flex items-center justify-between gap-4'}>
                                <FilterBar quickFilters={quickFilterKeys} />
                                {filterGroups.length > 1 && !readOnly && <DeleteGroupButton />}
                            </div>
                        </FilterGroupProvider>
                    );
                })}
        </div>
    );
};

export { FilterGroupBar };
